/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ESchoolEducationLevel } from "../types/ESchoolEducationLevel.ts";

/**
 * @description 0 = Uninformed | 1 = FullTop | 2 = Master | 3 = Doctor | 4 = Expert |
 */
export const eSchoolEducationLevelSchema = z
  .union([z.literal(0), z.literal(1), z.literal(2), z.literal(3), z.literal(4)])
  .describe(
    "0 = Uninformed | 1 = FullTop | 2 = Master | 3 = Doctor | 4 = Expert | ",
  ) as unknown as ToZod<ESchoolEducationLevel>;
